<template>
  <form @submit="handleSubmit">
    <div role="group" class="input-wrapper mt-4">
      <label for="title">Név:</label>
      <b-form-input
        id="title"
        v-model="title"
        :state="titleState"
        aria-describedby="title-live-feedback"
        placeholder="Adja meg az alkategória nevét"
        trim
      ></b-form-input>

      <!-- This will only be shown if the preceding input has an invalid state -->
      <b-form-invalid-feedback id="input-live-feedback">
        Legalább 5 karakter hosszú
      </b-form-invalid-feedback>

      <!-- This is a form text block (formerly known as help block) -->
      <!-- <b-form-text id="input-live-help">Alkategória neve</b-form-text> -->
    </div>

    <b-row class="px-3 pb-4 d-flex justify-content-center mt-4">
      <b-button @click="goBack" class="mr-2 mb-2">Vissza</b-button>
      <b-button :disabled="!titleState" variant="success" type="submit" class="mb-2">Változtatások mentése</b-button>
    </b-row>
  </form>
</template>

<script>
import { patchSubCategory } from '../api/fundMapCategories'
export default {
  props: {
    category: { type: Object, required: true }
  },
  computed: {
    titleState() {
      return this.title.length > 4 ? true : false
    }
  },
  data() {
    return {
      title: ''
    }
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault()
      try {
        const patchedSubCategory = await patchSubCategory(this.category._id, {
          title: this.title
        })
        this.$emit('patched-sub-category', patchedSubCategory)
      } catch (e) {
        console.log('Patching sub category error')
      }
      this.title = ''
    },
    goBack(e) {
      e.preventDefault()
      this.$bvModal.hide('edit-sub-category')
    }
  },
  mounted() {
    this.title = this.category.title
  }
}
</script>

<style scoped>
.input-wrapper {
  padding-inline: 0;
  max-width: 500px;
  margin: 0 auto;
}
.input-wrapper > * {
  text-align: left !important;
  font-size: 16px;
}
.input-wrapper label {
  width: 100%;
  padding: 0;
  color: #000;
  font-weight: 700;
  font-size: 12px;
}
</style>
